import BodyText from 'components/text/BodyText';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const PillButtonText: FunctionComponent<Props> = props => {
    const { children = props.text, className = '', testId = TEST_ID } = props;

    return (
        <BodyText className={`${className} ${styles.pillButtonText}`} testId={testId}>
            {children}
        </BodyText>
    );
};

export default PillButtonText;
